module.exports = __webpack_public_path__ + "img/special_homeStarElimination.bbefde5c.png";